import React from 'react';
import { useTranslation } from 'react-i18next';
import pkg from '../../../package.json';

const About = () => {
	const { t } = useTranslation();

	return (
		<div>
	    	<h1>{t('about.title')}</h1>
            <div
                dangerouslySetInnerHTML={
                    {__html: t('about.about', { 'interpolation': {'escapeValue': false} })}
                }
            />
			<div className='p'>
				Version: {pkg.version}
			</div>
		</div>
	);
};

export default About;
